import React, { useState } from "react";
import { Card, CardBody, Col, DropdownItem, DropdownMenu, DropdownToggle, Label, Row, UncontrolledDropdown } from "reactstrap";
import "../global/GlobalCSS.css";
import BulkCarrier from "../Media/bulk_carrier.png";
import Tanker from "../Media/tanker.png";
import Cargo from "../Media/general_cargo.png";
import GasCarrier from "../Media/gas_carrier.png";
import Container from "../Media/container_carrier.png";
import LNGCarrier from "../Media/lng_carrier.png";
import RoRo from "../Media/ro_ro.png";
import ToolTip from "./ToolTip";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setVesselID } from "../Store/Generic/ReportingSlice";
import { hasRole } from "utils/auth/authUtils";
import { Roles } from "shared/constants";
import env from "environment_system/env_system";
import { formattooltip } from "GenericForms/Helper";

const VesselCard = ({ Vessels }: { Vessels: any[] }) => {
    /** State variables start */
    const [flagError, setFlagError] = useState<Array<any>>([]);
    const dispatch = useDispatch();
    const [hoverId, setHoverId] = useState<string | null>(null);
    /** State variables end */

    /**
     * Returns type of image based on vessel type
     *
     * @param type
     * @returns string
     */
    const vesselType = (type: string) => {
        switch (type) {
            case "Tanker":
                return Tanker;
            case "Bulk Carrier":
                return BulkCarrier;
            case "General Cargo Ship":
                return Cargo;
            case "Gas Carrier":
                return GasCarrier;
            case "Container":
                return Container;
            case "LNG Carrier":
                return LNGCarrier;
            case "RoRo Cargo VC":
            case "RoRo Cargo Ship":
                return RoRo;
            default:
                return "";
        }
    };

    /** Set global Vessel ID */
    const handleVesselSelectionChanges = (vesselId: number) => {
        dispatch(setVesselID(vesselId));
    };

    /** Scroll functions */
    const scrollLeft = () => {
        const container = document.querySelector(".scroll-container");
        container.scrollLeft -= 675;
    };

    const scrollRight = () => {
        const container = document.querySelector(".scroll-container");
        container.scrollLeft += 675;
    };

    /** Function to scroll using mouse wheel */
    document
        ?.querySelector(".scroll-container")
        ?.addEventListener("wheel", function (e: any) {
            e.preventDefault();
            const container = document.querySelector(".scroll-container");
            container.scrollLeft += e.deltaY;
        });
    /** Scroll functions end */

    Vessels?.forEach((vessel: any) => {
        let arr: any[] = flagError;
        arr.push({
            id: vessel?.vessel_id,
            error: false
        })
    })

    return (
        <>
            <div className="scroll-container p-0">
                {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.MANAGER)) && (
                    <i
                        className="bx bx-chevron-left chevron left-chevron"
                        onClick={scrollLeft}
                    />
                )}
                {Vessels && Vessels?.map((vessel: any, index: number) => {
                    return (
                        <Card
                            key={index}
                            className="rounded-4 border-secondary vessel-card card mb-0 container-shadow"
                        >
                            <Row className="card-header bg-transparent border-secondary vessel-card-height p-1">
                                {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.MANAGER) || hasRole(Roles.ADMIN)) && (
                                    <Col lg={2}>
                                        <UncontrolledDropdown>
                                            <DropdownToggle
                                                id={`Click_here_to_view_vessel_analysis_report_${vessel?.vessel_id}`}
                                                type="button"
                                                color="link"
                                                className="px-2 py-0"
                                                onMouseEnter={() =>
                                                    setHoverId(`Click_here_to_view_vessel_analysis_report_${vessel?.vessel_id}`)
                                                }
                                                onMouseLeave={() => setHoverId(null)}
                                            >
                                                <i className="bx bx-menu" />
                                            </DropdownToggle>
                                            <DropdownMenu>
                                                <DropdownItem
                                                    tag={Link}
                                                    to="/cii_assessment"
                                                    onClick={() => handleVesselSelectionChanges(vessel?.vessel_id)}
                                                >
                                                    CII Assessment
                                                </DropdownItem>
                                                <DropdownItem
                                                    tag={Link}
                                                    to="/imo_dcs"
                                                    onClick={() => handleVesselSelectionChanges(vessel?.vessel_id)}
                                                >
                                                    IMO DCS
                                                </DropdownItem>
                                                <DropdownItem
                                                    tag={Link}
                                                    to="/eu_mrv_ets"
                                                    onClick={() => handleVesselSelectionChanges(vessel?.vessel_id)}
                                                >
                                                    EU MRV/ETS
                                                </DropdownItem>
                                                {env?.fuel_eu && (
                                                    <DropdownItem
                                                        tag={Link}
                                                        to="/fuel_eu"
                                                        onClick={() => handleVesselSelectionChanges(vessel?.vessel_id)}
                                                    >
                                                        Fuel EU
                                                    </DropdownItem>
                                                )}
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </Col>
                                )}
                                <Col lg={10} className="d-flex justify-content-start">
                                    <h5
                                        className="my-0 text-primary overflow-hidden"
                                        id={`vessel_${vessel?.vessel_id}_name`}
                                    >
                                        {vessel?.vessel_name?.toString()?.length > 13 ?
                                            `${vessel?.vessel_name?.toString()?.substring(0, 13)}...` :
                                            vessel?.vessel_name
                                        }
                                    </h5>
                                    {vessel?.vessel_name?.toString()?.length > 13 && (
                                        <ToolTip
                                            target={`vessel_${vessel?.vessel_id}_name`}
                                            message={vessel?.vessel_name}
                                        />
                                    )}
                                </Col>
                            </Row>
                            <CardBody
                                className="vessel-card-height mb-0"
                                style={{ position: 'relative' }}
                            >
                                {vessel?.is_under_maintenance && (
                                    <div
                                        style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            zIndex: 10,
                                            pointerEvents: 'auto'
                                        }}
                                        id={`maintenance-${vessel?.vessel_id}-div`}
                                    >
                                        <i
                                            className="dripicons-warning text-danger cursor-not-allowed"
                                            style={{
                                                fontSize: '58px',
                                                opacity: 1
                                            }}
                                            id={`maintenance-icon-${vessel?.vessel_id}`}
                                        />
                                        <ToolTip
                                            target={`maintenance-icon-${vessel?.vessel_id}`}
                                            message="Vessel under maintenance"
                                        />
                                    </div>
                                )}
                                <div
                                    style={{ opacity: vessel?.is_under_maintenance ? 0.5 : 1 }}
                                    className="cursor-not-allowed"
                                >
                                    <Row>
                                        <Col sm={3}>
                                            <ToolTip
                                                message={`Port of registry : ${vessel?.vessel_port_of_registry ?? "-"
                                                    } | ${vessel?.country_name ?? "-"}`}
                                                target={`flag-${vessel?.vessel_id}`}
                                            />
                                            <div className="bg-light bg-gradient">
                                                <img
                                                    alt={flagError.filter((item: any) => item?.id === vessel?.vessel_id)[0]?.error ? '' : 'Flag'}
                                                    src={`${env?.base_url}/country_master/get_country_image/?country_name=${vessel?.country_name}`}
                                                    height="25"
                                                    className="mb-0 mt-0 border"
                                                    id={`flag-${vessel?.vessel_id}`}
                                                    onError={() => {
                                                        setFlagError((prev) =>
                                                            prev.map((item) =>
                                                                item.id === vessel?.vessel_id ? { ...item, error: true } : item
                                                            )
                                                        );
                                                    }}
                                                />
                                            </div>
                                        </Col>
                                        <Col>
                                            <h6 className="card-title text-right">{vessel?.vessel_type}</h6>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <img
                                            alt={vessel?.vessel_type}
                                            src={vesselType(vessel?.vessel_type)}
                                            height="75"
                                            className="mb-2"
                                        />
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Row className="mt-2">
                                                <Col>
                                                    <Label className="card-title vessel-card-details mb-0">
                                                        IMO:{" "}
                                                        {vessel?.imo_number === undefined
                                                            ? "-"
                                                            : vessel?.imo_number}
                                                    </Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Label className="card-title vessel-card-details mb-0">
                                                        DWT:{" "}
                                                        {vessel?.vessel_dead_weight === undefined
                                                            ? "-"
                                                            : vessel?.vessel_dead_weight}
                                                    </Label>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col className="d-flex justify-content-end">
                                            {vessel?.cii_category === null ? (
                                                <div
                                                    className="card-height-3-8 ele_row bg-light bg-gradient width-100"
                                                    id="null_rating"
                                                >
                                                    <ToolTip
                                                        target="null_rating"
                                                        message="Yet to be calculated"
                                                    />
                                                    <i className="bx bx-minus icon_s23 pos-center pos-middle text-dark" />
                                                </div>
                                            ) : (
                                                <div
                                                    className={`CII-rating-${vessel?.cii_category} card-height-3-8 width-100`}
                                                >
                                                    <ToolTip
                                                        target="rating"
                                                        message="Projected CII rating"
                                                    />
                                                    <Label
                                                        className={"wid-data mb-0"}
                                                        id="rating"
                                                    >
                                                        {vessel?.cii_category}
                                                    </Label>
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            </CardBody>
                        </Card>
                    );
                })}
                {hoverId !== null &&
                    <ToolTip
                        target={hoverId}
                        message={formattooltip(hoverId)}
                        isOpen={hoverId !== null}
                    />
                }
                {(hasRole(Roles.ES_ADMIN) || hasRole(Roles.MANAGER)) && (
                    <i
                        className="bx bx-chevron-right chevron right-chevron"
                        onClick={scrollRight}
                    />
                )}
            </div>
        </>
    );
};

export default VesselCard;
